<template>
  <div class="group">
    <div
      v-if="title"
      class="header"
    >
      <div class="icon">
        <img
          :src="icon"
          :alt="title"
        >
      </div>
      <div class="title">
        {{ title }}
      </div>
    </div>
    <div class="list">
      <facility
        v-for="(facility, i) in facilities"
        :key="`facility-${title}-${i}`"
        :not-available="facility.notAvailable"
        :name="facility.name"
      />
    </div>
  </div>
</template>

<script>
import Facility from './tiny/Facility';

export default {
  name: 'facilities-group',
  components: {
    Facility,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    facilities: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.group {

  .item:not(:last-child) {
    margin-bottom: 12px;
  }
}
.header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  position: relative;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: contain;
  }
}

.title {
  color: #8995a6;
  font-size: 18px;
}
</style>
